import { createStructuredSelector } from 'reselect';

const watermarkStore = state => state?.watermarkStore ?? {};

const ingestStatusSelector = createStructuredSelector({
  ingestStatus: watermarkStore
});

export { ingestStatusSelector };
